import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setCSQ } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";



function CSQ(){
   
    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.api);

    let current_CSQ = myData.CSQ[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.CSQ)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="csq" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="csq" checked={checked} onChange={(e) => {dispatch(setCSQ(e.target.checked))}} />
                    <label htmlFor="csq" >CSQ</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current CSQ : {parseFloat(current_CSQ).toFixed(2)} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#4fc0d0"} />}
        </>
    );
}

export default CSQ;